import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'nirmithi-kendra';
  isAuth: any;
  constructor() {
    this.isAuth = window.location.href.includes('dashboard');
  }

}
